import { createTheme } from '@mui/material/styles';
import { red, green, grey, blue, yellow } from '@mui/material/colors';

const theme = ({ mode }) => createTheme({
    palette: {
        mode,
        /*
        primary: {
            main: '#605dec',
        },
        */
        panel1: mode === 'dark' ? 'black' : 'white',
        border1: mode === 'dark' ? grey[800] : grey[300],
        searchbarbackground: mode === 'dark' ? grey[700] : grey[200],
        background: {
            default: mode === 'dark' ? '#151515' : '#fafbfc',
            paper: mode === 'dark' ? '#000000' : '#ffffff',
        },
        'chip-request-new': {
            main: '#9CA3AF',
            contrastText: '#fff',
        },
        'chip-sent-to-endcustomer': {
            main: '#2185D0',
            contrastText: '#fff',
        },
        'chip-opened-by-customer': {
            main: '#DB74FF',
            contrastText: '#fff',
        },
        'chip-accepted': {
            main: green[500],
            contrastText: '#fff',
        },
        'chip-won': {
            main: green[500],
            contrastText: '#fff',
        },
        'chip-lost': {
            main: red[500],
            contrastText: '#fff',
        },
        'chip-submitted': {
            main: '#AC73E5',
            contrastText: '#fff',
        },
        'supplier-filter': {
            root: {
                background: 'green',
                '& input': {
                    color: '#FFF',
                }
            }
        },
        'monada-button': {
            main: mode === 'dark' ?  '#757ce8' : '#605DE4',
            contrastText: '#ffffff',
            dark: '#4d4ab6',
        },
        'black-button': {
            main: '#000000',
            contrastText: '#ffffff',
            dark: '#4d4ab6',
        },
        oneoffbuilderfields: {
            main: '#667085',
            contrastText: '#ffffff',
            dark: grey[500],
        }
    },
    typography: {
        fontFamily: [
            'Poppins',
            'sans-serif',
        ].join(','),
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: '#F9FAFB',
                        borderRadius: '6px',
                        fontSize: '13px',
                        '& fieldset': {
                            borderColor: '#E5E7EB',
                            borderWidth: '1px',
                        },
                        '&:hover fieldset': {
                            borderColor: '#E5E7EB',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#2563EB',
                            borderWidth: '1px',
                        },
                        '&.Mui-focused': {
                            backgroundColor: '#FFFFFF',
                        },
                    },
                    '& .MuiInputBase-input': {
                        fontSize: '13px',
                        padding: '8px 12px',
                        '&::placeholder': {
                            color: '#9CA3AF',
                            opacity: 1,
                            fontSize: '13px',
                        },
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: '#F9FAFB',
                    borderRadius: '6px',
                    fontSize: '13px',
                    '& fieldset': {
                        borderColor: '#E5E7EB',
                        borderWidth: '1px',
                    },
                    '&:hover fieldset': {
                        borderColor: '#E5E7EB',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#2563EB',
                        borderWidth: '1px',
                    },
                    '&::placeholder': {
                        color: '#9CA3AF',
                        opacity: 1,
                    },
                    '&.Mui-focused': {
                        backgroundColor: '#FFFFFF',
                    },
                },
                input: {
                    fontSize: '13px',
                    padding: '8px 12px',
                    '&::placeholder': {
                        color: '#9CA3AF',
                        opacity: 1,
                        fontSize: '13px',
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                    '&.MuiOutlinedInput-root': {
                        backgroundColor: '#F9FAFB',
                        borderRadius: '6px',
                        '& fieldset': {
                            borderColor: '#E5E7EB',
                        },
                        '&:hover fieldset': {
                            borderColor: '#E5E7EB',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#2563EB',
                        },
                        '&.Mui-focused': {
                            backgroundColor: '#FFFFFF',
                        },
                    },
                    '&.MuiInput-root': {
                        backgroundColor: '#F9FAFB',
                        borderRadius: '6px',
                        '&:before': {
                            borderBottom: 'none',
                        },
                        '&:after': {
                            borderBottom: '2px solid',
                            borderBottomColor: '#2563EB',
                        },
                        '&:hover:not(.Mui-disabled):before': {
                            borderBottom: 'none',
                        },
                    },
                },
                input: {
                    fontSize: '13px',
                    padding: '8px 12px',
                    '&::placeholder': {
                        color: '#9CA3AF',
                        opacity: 1,
                        fontSize: '13px',
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                    '&.MuiOutlinedInput-root': {
                        backgroundColor: '#F9FAFB',
                        borderRadius: '6px',
                        '& fieldset': {
                            borderColor: '#E5E7EB',
                        },
                        '&:hover fieldset': {
                            borderColor: '#E5E7EB',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#2563EB',
                        },
                        '&.Mui-focused': {
                            backgroundColor: '#FFFFFF',
                        },
                    },
                },
            },
            defaultProps: {
                MenuProps: {
                    PaperProps: {
                        sx: {
                            '& .MuiMenuItem-root': {
                                fontSize: '11px',
                                padding: '4px 12px',
                                minHeight: '32px',
                            },
                        },
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '11px',
                    padding: '4px 12px',
                    minHeight: '32px',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                    color: '#9CA3AF',
                    fontWeight: 400,
                    transform: 'translate(14px, 8px) scale(1)',
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -9px) scale(0.75)',
                        color: '#6B7280',
                    },
                    '&.Mui-focused': {
                        color: '#2563EB',
                    },
                },
                outlined: {
                    transform: 'translate(14px, 8px) scale(1)',
                    '&.MuiInputLabel-shrink': {
                        transform: 'translate(14px, -9px) scale(0.75)',
                        color: '#6B7280',
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: '13px',
                },
            },
        },
    },
});

export default theme;
